import React from "react";
import data from "../../json/Allproducts/Allproducts.json";
import { Link } from "react-router-dom";
const Section2 = ({ data }) => {
  return (
    <div className="w-full hidden  md:flex justify-center">
      <div className="2xl:container flex flex-col px-6 md:py-20 md:px-20">
        <h1 className="text-24  sm:text-32  lg:text-48 text-primarycolor text-center pb-20 font-bold"> {data.Title}</h1>
        <div className="w-full">
          <img src={process.env.PUBLIC_URL + data.img} alt="img" />
        </div>

      </div>
    </div>
  );
};

export default Section2;
